export default __webpack_public_path__ + "static/media/candle.4eeadc6e.jpg";